import { extendTheme } from '@chakra-ui/react';
import foundations from './foundations';
import components from './components';

const theme = extendTheme({
  styles: {
    global: {
      'html, body': {
        /* CSS custom property for the polyfill */
        '--scroll-behavior': 'smooth',
        scrollBehavior: 'smooth',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
      body: {
        overflowX: 'hidden',
        background: 'black',
        color: 'white',
      },
    },
  },
  ...foundations,
  components,
});

export default theme;
